<div style="min-height: 400px;">
    <div class="inputs input-grid-gaps">
        <!-- Send or receive date -->
        <app-date-input
            class="fr-2"
            [form]="form"
            [id]="direction === 'incoming' ? 'receiveDate' : 'sendDate'"
            [showTime]="true"
            [prefix]="translatePrefix"
        >
        </app-date-input>

        <!-- Mail number -->
        <app-number-input
            [form]="form"
            id="mailNumber"
            [prefix]="translatePrefix"
            class="fr-1">
        </app-number-input>

        <!-- Type -->
        <app-select-input
            [form]="form"
            id="type"
            [prefix]="translatePrefix"
            [staticOptions]="serviceMailsTypeEnumOptions"
            class="fr-1">
        </app-select-input>

        <!-- Info -->
        <app-text-area-input
            [form]="form"
            id="info"
            [prefix]="translatePrefix"
            class="fr-4">
        </app-text-area-input>

        <!-- Sender or recipient -->
        <app-input-text-autocomplete
            [form]="form"
            [id]="direction === 'incoming' ? 'sender' : 'recipient'"
            [label]="translatePrefix + 'fields.' + (direction === 'incoming' ? 'sender' : 'recipient')"
            class="fr-4"
            [suggestions]="store.data.getServiceMailRecipients()"
            [showEmptyMessage]="false"
        ></app-input-text-autocomplete>

        <app-multi-select-input
            [form]="form"
            [infiniteScroll]="usersScroll()"
            [prefix]="translatePrefix"
            id="userIds"
            valueKey="id"
            class="fr-2"
        >
            <ng-template #item let-item>
                <div class="flex-column gap-xx-small">
                    <div>{{ item | formatPerson }}</div>
                    @if (item.name?.length) {
                        <div class="font-size-x-small text-secondary">{{ item.email }}</div>
                    }
                </div>
            </ng-template>
            <ng-template #selectedItems let-items>
                @if (items && items.length) {
                    <div class="flex gap-small">
                        @for (item of items; track $index) {
                            <app-user-chip
                                [user]="item"
                                [renderDetails]="false"
                                [renderType]="UserChipRenderTypeEnum.User"
                            ></app-user-chip>
                        }
                    </div>
                } @else {
                    {{ "service.operationalReport.fields.clients" | translate }}
                }
            </ng-template>
        </app-multi-select-input>

        <!-- Deadline -->
        @if (direction === 'incoming') {
            <app-date-input
                [form]="form"
                id="deadline"
                [prefix]="translatePrefix"
                class="fr-2">
            </app-date-input>
        }

        <!-- State -->
        <app-select-input
            [form]="form"
            id="state"
            [prefix]="translatePrefix"
            [staticOptions]="serviceMailsStateEnumOptions"
            class="fr-4">
        </app-select-input>

        <!-- Parcel file -->
        <app-file-upload-box
            #parcelFileUploadBox
            class="fr-2"
            [label]="translatePrefix + 'fields.parcelFileId'"
            [multiple]="false"
            [existingFiles]="form.value.parcelFileId && [form.value.parcelFileId]">
        </app-file-upload-box>

        <!-- Related file -->
        <app-file-upload-box
            #relatedFileUploadBox
            class="fr-2"
            [label]="translatePrefix + 'fields.relatedFileId'"
            [multiple]="false"
            [existingFiles]="form.value.relatedFileId && [form.value.relatedFileId]">
        </app-file-upload-box>

        <!-- Note -->
        <app-text-area-input
            [form]="form"
            id="note"
            [prefix]="translatePrefix"
            class="fr-4">
        </app-text-area-input>
    </div>
</div>
